module.exports = __webpack_public_path__ + "static/media/hover.ea370297.png";